export default __webpack_public_path__ + "static/media/Uber-clone.d052fcd9.png";